import { render, staticRenderFns } from "./popup-notifier.vue?vue&type=template&id=5fab5ae4&scoped=true"
import script from "./popup-notifier.vue?vue&type=script&lang=js"
export * from "./popup-notifier.vue?vue&type=script&lang=js"
import style0 from "./popup-notifier.vue?vue&type=style&index=0&id=5fab5ae4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fab5ae4",
  null
  
)

export default component.exports